import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrentUser } from 'src/app/@compartido/interfaces/currentUser.interface';

// Clase que encapsula un BehaviorSubject con su getter, setter y observable
class SubjectWrapper<T> {
    private subject: BehaviorSubject<T>;

    constructor(initialValue: T) {
        this.subject = new BehaviorSubject<T>(initialValue);
    }

    get value(): T {
        return this.subject.getValue();
    }

    set set(newValue: T) {
        this.subject.next(newValue);
    }

    get get(): Observable<T> {
        return this.subject.asObservable();
    }
}


@Injectable({
    providedIn: 'root'
})
export class BusDataService {
    private subjects: { [key: string]: SubjectWrapper<any> } = {};
  
    // Método para crear o obtener un SubjectWrapper existente
    getOrCreateSubject<T>(key: string, initialValue: T): SubjectWrapper<T> {
      if (!this.subjects[key]) {
        this.subjects[key] = new SubjectWrapper<T>(initialValue);
      }
      return this.subjects[key];
    }

    currentUser:CurrentUser = {
        empresa: "Rotoplas",
        rolName: "admin",
        isAdmin: true
    }

    constructor() {
        this.getOrCreateSubject('mySubject', 10);
        this.getOrCreateSubject('currentUser', this.currentUser);
      

     }

    


  }